/**
 * Şehir kataloğu (Story 19.1 — bulgu 9).
 *
 * Şehir SERBEST METİN DEĞİLDİR: "İstanbul / istanbul / İSTANBUL" tek gruba düşsün
 * diye alan kapalı bir katalogtan seçilir. Bu dosya TEK kaynaktır — web, mobil,
 * API doğrulaması ve keşif filtresi aynı listeyi okur.
 *
 * Kod biçimi ISO 3166-2:TR ile aynıdır (`TR-34`), böylece ileride başka ülke
 * eklendiğinde şema değişmez. Yurt dışı etkinlikler için `ABROAD` kullanılır ve
 * ülke `venue_country_code` alanında durur.
 *
 * ETİKETLER BURADA DEĞİLDİR: ad `i18n` sözlüğünden (`catalog.city.<kod>`) gelir,
 * TR ve EN birlikte tutulur (CLAUDE.md: metin koda gömülmez).
 */
/** Türkiye illeri — plaka sırası (katalog sırası da budur). */
export const TURKEY_CITY_CODES = [
    'TR-01',
    'TR-02',
    'TR-03',
    'TR-04',
    'TR-05',
    'TR-06',
    'TR-07',
    'TR-08',
    'TR-09',
    'TR-10',
    'TR-11',
    'TR-12',
    'TR-13',
    'TR-14',
    'TR-15',
    'TR-16',
    'TR-17',
    'TR-18',
    'TR-19',
    'TR-20',
    'TR-21',
    'TR-22',
    'TR-23',
    'TR-24',
    'TR-25',
    'TR-26',
    'TR-27',
    'TR-28',
    'TR-29',
    'TR-30',
    'TR-31',
    'TR-32',
    'TR-33',
    'TR-34',
    'TR-35',
    'TR-36',
    'TR-37',
    'TR-38',
    'TR-39',
    'TR-40',
    'TR-41',
    'TR-42',
    'TR-43',
    'TR-44',
    'TR-45',
    'TR-46',
    'TR-47',
    'TR-48',
    'TR-49',
    'TR-50',
    'TR-51',
    'TR-52',
    'TR-53',
    'TR-54',
    'TR-55',
    'TR-56',
    'TR-57',
    'TR-58',
    'TR-59',
    'TR-60',
    'TR-61',
    'TR-62',
    'TR-63',
    'TR-64',
    'TR-65',
    'TR-66',
    'TR-67',
    'TR-68',
    'TR-69',
    'TR-70',
    'TR-71',
    'TR-72',
    'TR-73',
    'TR-74',
    'TR-75',
    'TR-76',
    'TR-77',
    'TR-78',
    'TR-79',
    'TR-80',
    'TR-81',
];
/** Yurt dışı — ülke bilgisi `venueCountryCode` alanında taşınır. */
export const CITY_CODE_ABROAD = 'ABROAD';
export const CITY_CODES = [...TURKEY_CITY_CODES, CITY_CODE_ABROAD];
const CITY_CODE_SET = new Set(CITY_CODES);
export function isCityCode(value) {
    return typeof value === 'string' && CITY_CODE_SET.has(value);
}
/**
 * Türkçe duyarlı normalleştirme: aksan kalkar, `İ/I/ı/i` tek harfe iner, boşluk
 * ve kesme işareti atılır. Hem göç eşlemesi hem de aranabilir liste bunu kullanır
 * ("istanbul", "İSTANBUL", "Istanbul" aynı anahtara düşer).
 */
export function normalizeCityName(value) {
    return value
        .replace(/İ/g, 'i')
        .replace(/I/g, 'i')
        .replace(/ı/g, 'i')
        .replace(/Ş/g, 's')
        .replace(/ş/g, 's')
        .replace(/Ğ/g, 'g')
        .replace(/ğ/g, 'g')
        .replace(/Ü/g, 'u')
        .replace(/ü/g, 'u')
        .replace(/Ö/g, 'o')
        .replace(/ö/g, 'o')
        .replace(/Ç/g, 'c')
        .replace(/ç/g, 'c')
        .replace(/Â|â/g, 'a')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]/g, '');
}
/**
 * Normalleştirilmiş ad → katalog kodu. Değerler `normalizeCityName` çıktısıdır;
 * yaygın alternatif yazımlar (Afyon, Maraş, Urfa, İçel…) da buradadır.
 *
 * Migration bu tabloyu KOPYALAR (tarihsel kayıt dondurulur) ve
 * `city-catalog.spec.ts` iki listenin ayrışmadığını kanıtlar — claim deseni.
 */
export const CITY_NAME_TO_CODE = {
    adana: 'TR-01',
    adiyaman: 'TR-02',
    afyonkarahisar: 'TR-03',
    afyon: 'TR-03',
    agri: 'TR-04',
    amasya: 'TR-05',
    ankara: 'TR-06',
    antalya: 'TR-07',
    artvin: 'TR-08',
    aydin: 'TR-09',
    balikesir: 'TR-10',
    bilecik: 'TR-11',
    bingol: 'TR-12',
    bitlis: 'TR-13',
    bolu: 'TR-14',
    burdur: 'TR-15',
    bursa: 'TR-16',
    canakkale: 'TR-17',
    cankiri: 'TR-18',
    corum: 'TR-19',
    denizli: 'TR-20',
    diyarbakir: 'TR-21',
    edirne: 'TR-22',
    elazig: 'TR-23',
    erzincan: 'TR-24',
    erzurum: 'TR-25',
    eskisehir: 'TR-26',
    gaziantep: 'TR-27',
    antep: 'TR-27',
    giresun: 'TR-28',
    gumushane: 'TR-29',
    hakkari: 'TR-30',
    hatay: 'TR-31',
    antakya: 'TR-31',
    isparta: 'TR-32',
    mersin: 'TR-33',
    icel: 'TR-33',
    istanbul: 'TR-34',
    izmir: 'TR-35',
    kars: 'TR-36',
    kastamonu: 'TR-37',
    kayseri: 'TR-38',
    kirklareli: 'TR-39',
    kirsehir: 'TR-40',
    kocaeli: 'TR-41',
    izmit: 'TR-41',
    konya: 'TR-42',
    kutahya: 'TR-43',
    malatya: 'TR-44',
    manisa: 'TR-45',
    kahramanmaras: 'TR-46',
    maras: 'TR-46',
    mardin: 'TR-47',
    mugla: 'TR-48',
    mus: 'TR-49',
    nevsehir: 'TR-50',
    nigde: 'TR-51',
    ordu: 'TR-52',
    rize: 'TR-53',
    sakarya: 'TR-54',
    adapazari: 'TR-54',
    samsun: 'TR-55',
    siirt: 'TR-56',
    sinop: 'TR-57',
    sivas: 'TR-58',
    tekirdag: 'TR-59',
    tokat: 'TR-60',
    trabzon: 'TR-61',
    tunceli: 'TR-62',
    sanliurfa: 'TR-63',
    urfa: 'TR-63',
    usak: 'TR-64',
    van: 'TR-65',
    yozgat: 'TR-66',
    zonguldak: 'TR-67',
    aksaray: 'TR-68',
    bayburt: 'TR-69',
    karaman: 'TR-70',
    kirikkale: 'TR-71',
    batman: 'TR-72',
    sirnak: 'TR-73',
    bartin: 'TR-74',
    ardahan: 'TR-75',
    igdir: 'TR-76',
    yalova: 'TR-77',
    karabuk: 'TR-78',
    kilis: 'TR-79',
    osmaniye: 'TR-80',
    duzce: 'TR-81',
    yurtdisi: CITY_CODE_ABROAD,
    abroad: CITY_CODE_ABROAD,
};
/**
 * Serbest metni katalog koduna çevirir. Eşlenemezse `null` döner — çağıran
 * SESSİZCE BOŞ BIRAKMAZ, karar listesine yazar (Story 19.1 kabul kriteri).
 */
export function resolveCityCode(value) {
    if (!value)
        return null;
    const normalized = normalizeCityName(value);
    if (!normalized)
        return null;
    if (isCityCode(value.toUpperCase()))
        return value.toUpperCase();
    return CITY_NAME_TO_CODE[normalized] ?? null;
}
/**
 * Kod → o koda düşen TÜM normalleştirilmiş yazımlar (alternatifler dâhil:
 * Afyon, Maraş, Antep, İzmit, İçel…).
 *
 * İKİNCİ BİR LİSTE YAZILMAZ: tablo `CITY_NAME_TO_CODE`un tersidir. Katalog
 * büyüdüğünde arama da kendiliğinden büyür.
 */
export const CITY_CODE_ALIASES = Object.entries(CITY_NAME_TO_CODE).reduce((acc, [alias, code]) => {
    (acc[code] ??= []).push(alias);
    return acc;
}, {});
/**
 * ŞEHİR SEÇİCİ ARAMASI — tek kaynak (mobil elle test · madde 8).
 *
 * Kullanıcı "izmir" yazınca "İzmir", "maras" yazınca "Kahramanmaraş" bulunur:
 * hem GÖRÜNEN ad hem de katalogdaki alternatif yazımlar taranır ve ikisi de
 * `normalizeCityName`den geçer (Türkçe katlaması tek yerde).
 *
 * Etiket ÇAĞIRANDAN gelir: ad i18n sözlüğündedir, katalog dosyasında değil.
 */
export function cityMatchesQuery(code, label, query) {
    const needle = normalizeCityName(query);
    if (!needle)
        return true;
    if (normalizeCityName(label).includes(needle))
        return true;
    return (CITY_CODE_ALIASES[code] ?? []).some((alias) => alias.includes(needle));
}
/**
 * ŞEHİR SEÇİCİ SATIRLARI — web `CityCombobox` ve mobil `CityPicker` için tek
 * kaynak (elle test B-06). Satırlar `CITY_CODES` kataloğundan kurulur, ad
 * çağırandan gelir (i18n sözlüğü katalog dosyasında değildir).
 *
 * Sıra: katalog dışı "Yurt dışı" kovası BAŞTA (aramasız erişilir, 17A Düşük-3),
 * kalanı kullanıcının dilinde alfabetik ("İzmir" TR'de "Isparta"dan sonradır).
 *
 * Alan adı `cityCode`: `.code` eki hata kodu kapısının deseniyle çakışıyor
 * (`error-message.guard.spec` KURAL 2) ve şehir kodu bir hata kodu değil.
 */
export function cityPickerRows(labelOf, locale) {
    const rank = (cityCode) => (cityCode === CITY_CODE_ABROAD ? 0 : 1);
    return CITY_CODES.map((cityCode) => ({ cityCode, label: labelOf(cityCode) })).sort((a, b) => rank(a.cityCode) - rank(b.cityCode) || a.label.localeCompare(b.label, locale));
}
/** Seçici satırlarını yazılan metne göre süzer (`cityMatchesQuery`, boş sorgu hepsini geçirir). */
export function filterCityPickerRows(rows, query) {
    return rows.filter((row) => cityMatchesQuery(row.cityCode, row.label, query));
}
//# sourceMappingURL=city-catalog.js.map